import React from 'react';
import { FormattedTime, FormattedMessage } from 'react-intl';
import DeliverableIdChip from '~/features/deliverables/components/DeliverableIdChip';
import UpdateEventOutcome from '~/features/updateEvents/components/UpdateEventOutcome';
import UpdateEventType from '~/features/updateEvents/components/UpdateEventType';
import FieldOrNoData from '~/features/base/components/FieldOrNoData';
import ShortBaseSwVersion from '~/features/baseSwVersions/components/ShortBaseSwVersion';
import Chip from '~/features/base/components/Chip';
import DeliverableChip from '~/features/deliverables/components/DeliverableChip';
import { toShortSemanticVersion, toShortVersion } from '~/features/base/utils/versionNumberConverter';
import { DeliverableType } from '~/features/deliverables/constants/DeliverableType';
import VersionTransition from '~/features/updateEvents/components/VersionTransition';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';
import { outcomes, SUCCESS, FAILED } from '~/features/updateEvents/constants/outcomes';

const getDeliverableType = (updateEventType) => {
    const updateTypeSplit = updateEventType.split('_');
    let deliverableType = '';
    if (updateTypeSplit.length > 0) {
        deliverableType = updateTypeSplit[0];
        switch (deliverableType) {
            case 'PACKAGE':
                deliverableType = 'app';
                break;
            case 'DELIVERABLE':
                deliverableType = 'cm4g';
                break;
            default:
                break;
        }
    }
    return deliverableType.toLowerCase();
};
export const updateEventColumnDescriptors = [{
    id: 'hwSerial',
    field: 'hwSerial',
    label: 'intl-msg:hwSerial',
    format: field => <FieldOrNoData field={field}/>,
}, {
    id: 'type',
    field: 'type',
    label: 'intl-msg:type',
    format: (field, item) => <UpdateEventType value={field} bundleVersion={item.bundle?.version} />,
}, {
    id: 'deliverableId',
    field: 'deliverableId',
    label: 'intl-msg:deliverableId',
    format: (field, item) => {
        return (<DeliverableChip deliverableId={field}
                                 deliverableType={getDeliverableType(item.type)}
                                 deliverableVersion={item?.targetVersion}
                                 displayValue={field}
        />);
    },
}, {
    id: 'versionTransition',
    field: 'previousVersion',
    label: 'intl-msg:version',
    format: (field, item) => (
        <VersionTransition
            previousVersion={item.previousVersion}
            targetVersion={item.targetVersion}
            outcome={item.outcome}
            deliverableId={item.deliverableId}
            deliverableType={getDeliverableType(item.type)}
        />
    ),
},
    {
        id: 'outcome',
        field: 'outcome',
        label: ' ',
        format: field => <UpdateEventOutcome value={field} />,
    },
    {
    id: 'timestamp',
    field: 'timestamp',
    label: 'intl-msg:timestamp',
    format: field => <FormattedTime value={field} year='numeric' month='2-digit' day='2-digit'/>,
}, {
    id: 'info',
    field: 'info',
    label: ' ',
    format: field => field ? (
        <OverlayTrigger
            placement='top'
            overlay={
                <Tooltip id='info-tooltip'>
                    {field}
                </Tooltip>
            }
        >
            <span className="rioglyph rioglyph-info-sign text-color-info" />
        </OverlayTrigger>
    ) : null,
}];
